import React from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';

import { useModal } from 'hooks/modal/useModal';

import ModalCreate from '../Modals/ModalCreate';
import { FilterDashboardMotifMef } from '../types';

import Filter from './Filter/Filter';

import './DashboardHeader.less';

interface DashboardHeaderProps {
  totalCount: number;
  setFilter: (value: Partial<FilterDashboardMotifMef>) => void;
  filter: Partial<FilterDashboardMotifMef>;
}

function DashboardHeader({
  totalCount,
  filter,
  setFilter,
}: DashboardHeaderProps): React.ReactElement {
  const countString = `${totalCount} motif${totalCount > 1 ? 's' : ''} trouvé${
    totalCount > 1 ? 's' : ''
  }`;

  const modalCreation = useModal();

  const refreshDashboard = () => {
    setFilter({ ...filter });
  };

  return (
    <div>
      <div className="dashboard-header-fields header-referentiels">
        <Filter filter={filter} setFilter={setFilter}></Filter>
        <AntdButton
          icon={<PlusOutlined />}
          type="primary"
          shape="round"
          onClick={modalCreation.open}
        >
          Créer un motif de MEF
        </AntdButton>
        <ModalCreate
          visible={modalCreation.visible}
          close={modalCreation.close}
          refreshDashboard={refreshDashboard}
        />
      </div>
      <p>{countString}</p>
    </div>
  );
}

export default DashboardHeader;
